/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryTimExecutionReportResult
 */
export interface PalSubmissionListEntryTimExecutionReportResult {
    /**
     * 
     */
    level?: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecutionReportResult interface.
 */
export function instanceOfPalSubmissionListEntryTimExecutionReportResult(value: object): value is PalSubmissionListEntryTimExecutionReportResult {
    return true;
}

export function PalSubmissionListEntryTimExecutionReportResultFromJSON(json: any): PalSubmissionListEntryTimExecutionReportResult {
    return PalSubmissionListEntryTimExecutionReportResultFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionReportResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecutionReportResult {
    if (json == null) {
        return json;
    }
    return {
        
        'level': json['level'] == null ? undefined : json['level'],
    };
}

export function PalSubmissionListEntryTimExecutionReportResultToJSON(json: any): PalSubmissionListEntryTimExecutionReportResult {
    return PalSubmissionListEntryTimExecutionReportResultToJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionReportResultToJSONTyped(value?: PalSubmissionListEntryTimExecutionReportResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'level': value['level'],
    };
}

